import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { compose } from 'recompose'
import { get } from 'lodash'
import UserDropdown from 'components/Navigation/UserDropdown'
import { withUserContext } from '../../context/UserContext'
import { withWorkspaceContext } from '../../context/WorkspaceContext'
import { graphql } from 'react-apollo'
import HasDevCenterAccess from './graphql/queries/HasDevCenterAccess.graphql'
import currentRole from './graphql/queries/currentRole.graphql'

const withDevCenterAccess = graphql(HasDevCenterAccess, {
  props: ({ data, ownProps }) => {
    return {
      // Do _not_ include `Boolean(data.error)` here.
      // If the HasDevCenterAccess query fails, we want to continue showing the
      // menu.
      isErrored: ownProps.isErrored,
      isLoading: ownProps.isLoading || data.loading,
      hasDevCenterAccess:
        get(data, 'devCenterAccessApplication.status') === 'APPROVED'
    }
  }
})

const withCurrentRole = graphql(currentRole, {
  options: ({ workspace }) => ({
    variables: {
      resourceId: workspace.id
    }
  }),
  props: ({ data }) => {
    return {
      isWorkspaceOwner: data.isWorkspaceOwner
    }
  }
})

class UserDropdownApp extends PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.string.isRequired,
      isAdmin: PropTypes.bool,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    }),
    isErrored: PropTypes.bool,
    isLoading: PropTypes.bool,
    hasDevCenterAccess: PropTypes.bool.isRequired
  }

  render() {
    const {
      isLoading,
      isErrored,
      workspace,
      user,
      hasDevCenterAccess,
      isWorkspaceOwner
    } = this.props
    const currentUser = user || {}

    return (
      <UserDropdown
        isLoading={isLoading}
        isErrored={isErrored}
        user={currentUser}
        isContactSupportVisible={get(workspace, 'billing.isOnInvoicedPlan')}
        isPartnerPortalVisible={currentUser.isAdmin}
        workspacePlan={get(workspace, 'billing.planName')}
        showChangeWorkspace
        workspaceName={get(workspace, 'name', '')}
        workspaceSlug={get(workspace, 'slug', '')}
        isDeveloperCenterVisible={hasDevCenterAccess || currentUser.isAdmin}
        isWorkspaceOwner={isWorkspaceOwner}
      />
    )
  }
}

export default compose(
  withRouter,
  withWorkspaceContext,
  withUserContext,
  withDevCenterAccess,
  withCurrentRole
)(UserDropdownApp)
